import { Template, TemplateState, TemplateType } from "@/@types/flows/emailTemplates";
import { CreateTemplateDto, FiltersDto } from "@/@types/flows/emailTemplates/dtos";
import { ItemType, TemplateItem } from "@/@types/flows/emailTemplates/items";
import { emailService } from "@/app/emails/services/Email.service";
import { TemplateItemFactory } from "@/app/flows/emailTemplates/utils/TemplateItemFactory";
import httpManager from "@/app/shared/utils/httpManager";
import { toFormData } from "axios";
import { ProductName } from "@/app/shared/utils/constants";

import { TemplateItemsManager } from "@/app/flows/emailTemplates/utils/TemplateItemsManager";
import { TemplateHtmlBuilder } from "@/app/flows/emailTemplates/utils/TemplateHtmlBuilder";

class EmailTemplateService {
  private baseUrl = "/channels/email-templates";

  async getTemplatesList(filters: FiltersDto): Promise<Template[]> {
    const url = `${this.baseUrl}/?search=${filters.name}&status=${filters.state}&template_type=${filters.type}`;

    const response = await httpManager.get(url);

    return response.data.results;
  }

  async getTemplateById(id: number): Promise<Template> {
    const url = `${this.baseUrl}/${id}/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async create(createTemplateBody: Partial<CreateTemplateDto>): Promise<Template> {
    const url = `${this.baseUrl}/`;
    const { template_type } = createTemplateBody;

    const templateItems: TemplateItem[] = [];

    if (template_type === TemplateType.Html) {
      const htmlItem = TemplateItemFactory.create(ItemType.Html);
      htmlItem.content = createTemplateBody.template || "";
      templateItems.push(htmlItem);
    }

    const footerItem = TemplateItemFactory.create(ItemType.Footer);
    templateItems.push(footerItem);

    // Logic to generate a HTML string based on templateItems elements
    // const parsedTemplate = getHtmlString();

    const body = {
      ...createTemplateBody,
      template: "prueba",
      items: templateItems,
    } as CreateTemplateDto;

    const response = await httpManager.post(url, body);

    return response.data;
  }

  async update(id: number, updateTemplateDto: Partial<CreateTemplateDto>) {
    const url = `${this.baseUrl}/${id}/`;

    await httpManager.put(url, updateTemplateDto);
  }

  async uploadFile(id: number, file: File) {
    const url = `${this.baseUrl}/${id}/`;
    const body = { attachments: file };

    await httpManager.put(url, toFormData(body));
  }

  async toggleState(template: Template) {
    const url = `${this.baseUrl}/${template.id}/`;
    const body = {
      status:
        template.status === TemplateState.Active ? TemplateState.Inactive : TemplateState.Active,
    };

    await httpManager.put(url, body);
  }

  async makeCopy(id: number) {
    const url = `${this.baseUrl}/${id}/copy/`;

    await httpManager.post(url);
  }

  async delete(id: number) {
    const url = `${this.baseUrl}/${id}/`;

    await httpManager.delete(url);
  }

  async sendTestMail(template: Template, sender: number, email: string) {
    const currentItems = TemplateItemsManager.getCurrentItems();
    const items = currentItems && currentItems.length > 0 ? currentItems : template.items || [];

    let messageHtml = template.template;
    if (items && items.length > 0) {
      messageHtml = TemplateHtmlBuilder.generateHtmlTemplate(template, items);
    }

    await emailService.sendEmail({
      to_emails: email,
      bcc_emails: "",
      cc_emails: "",
      channel_customer: sender,
      message: messageHtml,
      subject: `[Plantilla ${ProductName} - ${template.name}]`,
    });
  }
}

export const emailTemplateService = new EmailTemplateService();
